import api from './api';
import type { CotizacionDto, CotizacionCreateRequest, PageResponse, EstadoCotizacion } from '@/types/cotizacion';

export const cotizacionesApi = {
  create: (data: CotizacionCreateRequest) =>
    api.post<CotizacionDto>('/cotizaciones', data).then((r) => r.data),

  findAll: (page = 0, size = 10) =>
    api.get<PageResponse<CotizacionDto>>('/cotizaciones', { params: { page, size, sort: 'fechaCreacion,desc' } }).then((r) => r.data),

  findById: (id: number) =>
    api.get<CotizacionDto>(`/cotizaciones/${id}`).then((r) => r.data),

  updateEstado: (id: number, estado: EstadoCotizacion) =>
    api.patch<CotizacionDto>(`/cotizaciones/${id}/estado`, null, { params: { estado } }).then((r) => r.data),

  getReporte: (desde: string, hasta: string) =>
    api.get<import('@/types/cotizacion').CotizacionDto[]>('/cotizaciones/reporte', { params: { desde, hasta } }).then((r) => r.data),

  getStats: () =>
    api.get<{ totalCotizaciones: number; valorAceptadas: number; cotizacionesHoy: number }>('/cotizaciones/stats').then((r) => r.data),
};
